import styled from "styled-components";
import InputWithLabel from "shared/components/InputWithLabel";
import { ChangeEvent } from "react";

interface tuitionModalProps{
    input:{
        paied:string,
        method:string,
        etc:string
    },
    onChange:(e: ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void,
    onCancelClick:() => void,
    onPayClick:() => void
}

const TuitionModal = ({input, onChange, onCancelClick, onPayClick}:tuitionModalProps) => {
    return(
        <Container>
            <Overlay onClick={onCancelClick} />
            <Box>
                <Header>
                    <Title>납부 설정</Title>
                    <CloseButton onClick={onCancelClick}>&times;</CloseButton>
                </Header>
                <Contents>
                    <FormGroup>
                        <Label>납부 방식</Label>
                        <Select name="method" onChange={onChange} value={input.method}>
                            <option value="현금">현금</option>
                            <option value="카드">카드</option>
                            <option value="계좌이체">계좌이체</option>
                        </Select>
                    </FormGroup>
                    <FormGroup>
                        <Label>납부 금액</Label>
                        <Input 
                            type="text" 
                            name="paied" 
                            value={input.paied} 
                            onChange={onChange}
                            placeholder="금액을 입력하세요"
                        />
                    </FormGroup>
                    <FormGroup>
                        <Label>비고</Label>
                        <Input 
                            type="text" 
                            name="etc" 
                            value={input.etc} 
                            onChange={onChange}
                            placeholder="비고 사항을 입력하세요"
                        />
                    </FormGroup>
                </Contents>
                <ButtonWrap>
                    <ButtonCancel onClick={onCancelClick}>취소</ButtonCancel>
                    <ButtonConfirm onClick={onPayClick}>납부</ButtonConfirm>
                </ButtonWrap>
            </Box>
        </Container>
    )
}

const Container = styled.div`
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
`;

const Overlay = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    backdrop-filter: blur(2px);
`;

const Box = styled.div`
    position: relative;
    background-color: white;
    width: 460px;
    border-radius: 16px;
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
    animation: slideUp 0.3s ease-out;
    z-index: 1001;

    @keyframes slideUp {
        from {
            transform: translateY(30px);
            opacity: 0;
        }
        to {
            transform: translateY(0);
            opacity: 1;
        }
    }
`;

const Header = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 24px 32px;
    border-bottom: 1px solid #eee;
`;

const Title = styled.h2`
    font-size: 24px;
    font-weight: 600;
    color: #2c3e50;
    margin: 0;
`;

const CloseButton = styled.button`
    background: none;
    border: none;
    font-size: 28px;
    color: #999;
    cursor: pointer;
    padding: 0;
    transition: color 0.2s;

    &:hover {
        color: #666;
    }
`;

const Contents = styled.div`
    padding: 32px;
    display: flex;
    flex-direction: column;
    gap: 24px;
`;

const FormGroup = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
`;

const Label = styled.label`
    font-size: 14px;
    font-weight: 500;
    color: #666;
`;

const Select = styled.select`
    width: 100%;
    padding: 12px 16px;
    font-size: 16px;
    border: 1px solid #ddd;
    border-radius: 8px;
    background-color: white;
    cursor: pointer;
    appearance: none;
    background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
    background-repeat: no-repeat;
    background-position: right 16px center;
    background-size: 16px;

    &:focus {
        outline: none;
        border-color: #2c3e50;
    }
`;

const Input = styled.input`
    width: 100%;
    padding: 12px 16px;
    font-size: 16px;
    border: 1px solid #ddd;
    border-radius: 8px;
    transition: border-color 0.2s;

    &:focus {
        outline: none;
        border-color: #2c3e50;
    }

    &::placeholder {
        color: #999;
    }
`;

const ButtonWrap = styled.div`
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding: 24px 32px;
    border-top: 1px solid #eee;
`;

const BaseButton = styled.button`
    padding: 12px 24px;
    font-size: 15px;
    font-weight: 500;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s;

    &:active {
        transform: scale(0.98);
    }
`;

const ButtonCancel = styled(BaseButton)`
    background-color: white;
    border: 1px solid #ddd;
    color: #666;

    &:hover {
        background-color: #f8f9fa;
        border-color: #c8c8c8;
    }
`;

const ButtonConfirm = styled(BaseButton)`
    background-color: #2c3e50;
    border: none;
    color: white;

    &:hover {
        background-color: #34495e;
    }
`;

export default TuitionModal;